export default "__VITE_ASSET__CdOOXF3y__"